import useCustomSearchParams from "./useCustomSearchParams";
import useStock from "./useStock";
import {useChartStockCode} from "../../@shared/stores/chartStore";

export default function useStockCode(): string {
  const { getParams } = useCustomSearchParams()

  const code = getParams('code', DEFAULT_CODE)
  const {stockCode} = useChartStockCode()
  const stock = useStock()

  return stock.state === 'loading' ? (code || stockCode) : stock.contents.code
}

const DEFAULT_CODE = 'KR7005930003'
